module.exports = __webpack_public_path__ + "img/background-color.3afbc47e.svg";